import axios from 'axios';
import { useEffect, useState } from 'react';
import { systemCode, xs_languageCode } from '..';
import { parsePageDataAvertisingMobile } from '../data/parsePageDataAdvertising';
import { getConfiguration } from '../data/utils/configuration';
import EmblaCarousel from './EmblaCarousel';

function BannersFetcher(props) {
    const [banners, setBanners] = useState([]);
    useEffect(() => {
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            try {
                const result = await axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    return;
                }
            }
        };

        const url = getConfiguration()['api']['getPageDataAdvertisingMobile'];
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: ''
        };
        fetchData(url, params, function(response) {
            const data = parsePageDataAvertisingMobile(response);
            if (data.carouselBanners != null) {
                setBanners(data.carouselBanners);
            }
        });

        return () => {
            didCancel = true;
        };
    }, []);

    if (banners?.length === 0) {
        return null;
    }

    return (
        <EmblaCarousel banners={banners} />
    );
}

export default BannersFetcher;